import SEOHead from '../../components/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import WhatWeDo from './components/WhatWeDo';
import Scenario from './components/Scenario';
import Benefits from './components/Benefits';
import WhoItsFor from './components/WhoItsFor';
import EasySetup from './components/EasySetup';
import LocalTrust from './components/LocalTrust';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  return (
    <>
      <SEOHead
        title="Lead Generation & SMS Automation for Local Businesses | Long Island"
        description="Automigo helps Long Island service businesses respond instantly to new leads and win more jobs. Automated SMS responses, smart follow-ups, and lead tracking for local contractors, home services, and professional services."
        keywords="lead generation Long Island, SMS automation for businesses, local service business automation, automated lead response, Long Island business tools, contractor lead management, home service automation"
        canonical={`${siteUrl}/`}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'Automigo',
          description: 'Lead generation and SMS automation for local service businesses on Long Island, NY.',
          url: siteUrl,
          logo: 'https://public.readdy.ai/ai/img_res/f48ccc04-9914-43af-8ca4-a7c20e3394e9.png',
          image: 'https://public.readdy.ai/ai/img_res/f48ccc04-9914-43af-8ca4-a7c20e3394e9.png',
          telephone: '',
          email: 'support@automigo.com',
          address: {
            '@type': 'PostalAddress',
            addressRegion: 'NY',
            addressLocality: 'Long Island',
            addressCountry: 'US'
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '40.789142',
            longitude: '-73.134738'
          },
          areaServed: [
            { '@type': 'City', name: 'Long Island' },
            { '@type': 'AdministrativeArea', name: 'Suffolk County' },
            { '@type': 'AdministrativeArea', name: 'Nassau County' }
          ],
          sameAs: [],
          priceRange: '$$',
          knowsAbout: [
            'Lead Generation',
            'SMS Automation',
            'Business Automation',
            'Local Service Business Marketing'
          ]
        }}
      />
      
      <div className="min-h-screen">
        <Navbar />
        <Hero />
        <Problem />
        <WhatWeDo />
        <Scenario />
        <Benefits />
        <WhoItsFor />
        <EasySetup />
        <LocalTrust />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}
